module.exports = __webpack_public_path__ + "5ee7a2511dfa364fb209bd584675f0b1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/corporate-knights-logo.png
// module id = 597
// module chunks = 0